// extracted by mini-css-extract-plugin
module.exports = {"ramqRow":"lab-selection-v2_ramqRow__ZAjHX","ramqLabel":"lab-selection-v2_ramqLabel__KM_nE"};